import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Music2, Mail, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";

const SOCIALS = [
  ["instagram", Instagram, "Instagram"],
  ["facebook", Facebook, "Facebook"],
  ["tiktok", Music2, "TikTok"],
  ["youtube", Youtube, "YouTube"],
];

const SHOP_LINKS = [
  ["/katalog", "Semua Produk"],
  ["/katalog?featured=true", "Unggulan"],
  ["/katalog?sort=newest", "Produk Baru"],
  ["/katalog?bestseller=true", "Paling Laris"],
  ["/wishlist", "Wishlist"],
];

/* Footer Global Commerce Premium (footer_style="premium-compact") — dark closing section.
   Warna 100% turunan token kanonik (--color-primary-dark / --color-primary / --color-accent);
   lihat .gcp-footer di index.css. Semua konten dari branding tenant; field kosong tidak dirender. */
export function PremiumFooter({ branding, copyright, poweredBy }) {
  const c = branding.contact || {};
  const general = branding.general || {};
  const socials = SOCIALS.filter(([k]) => c[k]);
  const description = branding.footer?.text || general.description || general.tagline;
  const storeName = general.name;
  const wa = c.whatsapp;

  return (
    <footer className="storefront-footer gcp-footer mt-16" data-footer-style="premium-compact" data-testid="footer-premium">
      <div className="gcp-footer-main">
        <div className="storefront-container grid grid-cols-1 gap-8 py-10 sm:py-12 md:grid-cols-12 md:gap-10">
          {/* LEFT — brand */}
          <div className="md:col-span-5 min-w-0">
            {/* Logo compact sudah memuat nama toko (invert = teks terang di latar gelap) */}
            <div className="flex items-center gap-3 min-w-0" data-testid="footer-brand" data-store-name={storeName || ""}>
              <Logo variant="compact" size="lg" to={null} invert />
            </div>
            {description ? <p className="gcp-footer-desc mt-2 max-w-sm" data-testid="footer-description">{description}</p> : null}
            {(c.email || wa) ? (
              <ul className="mt-4 space-y-1.5 text-sm" data-testid="footer-contact">
                {c.email ? (
                  <li><a href={`mailto:${c.email}`} className="gcp-footer-link inline-flex items-center gap-2" data-testid="footer-email"><Mail size={14} aria-hidden="true" />{c.email}</a></li>
                ) : null}
                {wa ? (
                  <li><a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="gcp-footer-link inline-flex items-center gap-2" data-testid="footer-whatsapp"><MessageCircle size={14} aria-hidden="true" />WhatsApp +{wa}</a></li>
                ) : null}
              </ul>
            ) : null}
            {socials.length > 0 ? (
              <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="footer-socials">
                {socials.map(([k, Icon, label]) => (
                  <a key={k} href={c[k]} target="_blank" rel="noopener noreferrer" aria-label={label}
                    className="gcp-social" data-testid={`footer-social-${k}`}>
                    <Icon size={16} />
                  </a>
                ))}
              </div>
            ) : null}
          </div>

          {/* MIDDLE — Belanja */}
          <nav className="md:col-span-3" aria-labelledby="footer-shop-heading">
            <div id="footer-shop-heading" className="gcp-footer-heading">Belanja</div>
            <ul className="space-y-2 text-sm">
              {SHOP_LINKS.map(([to, label]) => (
                <li key={label}><Link to={to} className="gcp-footer-link">{label}</Link></li>
              ))}
            </ul>
          </nav>

          {/* RIGHT — Bantuan & Kontak */}
          <nav className="md:col-span-4" aria-labelledby="footer-help-heading">
            <div id="footer-help-heading" className="gcp-footer-heading">Bantuan &amp; Kontak</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pesanan" className="gcp-footer-link">Lacak Pesanan</Link></li>
              <li><Link to="/login" className="gcp-footer-link">Masuk / Daftar</Link></li>
              {c.address ? <li className="gcp-footer-muted leading-relaxed" data-testid="footer-address">{c.address}</li> : null}
              {c.maps_url ? <li><a href={c.maps_url} target="_blank" rel="noopener noreferrer" className="gcp-footer-link" data-testid="footer-maps">Lihat Lokasi</a></li> : null}
            </ul>
          </nav>
        </div>
      </div>

      {/* Copyright bar — background = primary */}
      <div className="gcp-footer-bar" data-testid="footer-copyright">
        <div className="storefront-container flex flex-col items-center gap-1 py-3.5 text-xs sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} {copyright}. All rights reserved.</span>
          {poweredBy ? <span className="gcp-footer-muted" data-testid="footer-powered-by">Powered by {poweredBy}</span> : null}
        </div>
      </div>
    </footer>
  );
}
